<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xl="http://www.w3.org/1999/xlink" viewBox="1733.4178 1148.7621 17.237897 17.237897" width="17.237897" height="17.237897">
  <defs/>
  <g id="版面_____" fill-opacity="1" fill="none" stroke="none" stroke-dasharray="none" stroke-opacity="1">
    <title>主页（手机）</title>
    <g id="版面______图层_2">
      <title>图层 2</title>
      <g id="Graphic_77">
        <circle cx="1742.0367" cy="1157.381" r="8.61896224951993" fill="black"/>
      </g>
    </g>
  </g>
</svg>
</template>

<script>
export default {

}
</script>

<style scoped>
    svg {
        height:0.1rem;
    }
</style>